import React from 'react';
import styled from 'styled-components';
import { node } from 'prop-types';
import { typography, flexbox, space, layout, position, border, grid, color, system } from 'styled-system';

const StyledCard = styled('div')(
  ({ theme, highlight }) => ({
    borderRadius: theme.radii[1],
    boxShadow: `0 0 0 2px ${highlight ? theme.colors.blue : 'transparent'} inset, ${theme.shadow}`,
    backgroundColor: theme.colors.white,
    maxWidth: '100%',
    overflow: 'hidden',
    position: 'relative'
  }),
  system({
    cursor: true
  }),
  typography,
  layout,
  flexbox,
  space,
  position,
  border,
  grid,
  color
);

const Card = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <StyledCard ref={ref} {...props}>
      {children}
    </StyledCard>
  );
});

Card.propTypes = {
  children: node
};

export default Card;
